import { getJob } from "@gwrctl/shared";
import { TRACK_LABELS } from "./release.ts";

/**
 * Ekranda ham kimlik (`release.version.check`, `artifactId`) yerine insan diliyle
 * ad. Kimlik yine küçük ve ikincil olarak gösterilebilir; birincil etiket bu.
 */
export function jobTitle(type: string): string {
  return getJob(type)?.title ?? type;
}

const PARAM_LABELS: Record<string, string> = {
  semver: "Sürüm artışı",
  bumpVersionCode: "versionCode artsın",
  versionCode: "versionCode",
  commit: "Commit at",
  task: "Görev",
  clean: "Önce clean",
  production: "Üretim",
  artifactId: "AAB dosyası",
  track: "Track",
  rolloutPercent: "Yayın oranı",
  notes: "Sürüm notu",
  channel: "Kanal",
  message: "Mesaj",
  halt: "Durdur",
  mode: "Mod",
  langs: "Diller",
  updateGroupId: "Güncelleme grubu",
  deploymentId: "Web yayını",
  sinceRef: "Karşılaştırma noktası",
};

export function paramLabel(key: string): string {
  return PARAM_LABELS[key] ?? key;
}

/** Parametre değerini okunur hale getirir (JSON dökümü yok). */
export function paramValue(key: string, value: unknown): string {
  if (value === undefined || value === null || value === "") return "—";
  if (key === "track") return TRACK_LABELS[String(value)] ?? String(value);
  if (key === "rolloutPercent") return `%${String(value)}`;
  if (typeof value === "boolean") return value ? "evet" : "hayır";
  if (key === "artifactId") return String(value).split(/[\\/]/).pop() ?? String(value);
  if (Array.isArray(value)) return value.length ? value.join(", ") : "tümü";
  if (typeof value === "object") {
    const entries = Object.entries(value as Record<string, unknown>).filter(([, v]) => v !== "" && v != null);
    return entries.length ? entries.map(([k, v]) => `${k}: ${String(v)}`).join(" · ") : "—";
  }
  return String(value);
}

/** Bir işin parametrelerini tek satır özet olarak (app hariç). */
export function paramSummary(params: unknown): string {
  if (!params || typeof params !== "object") return "";
  // Boş değerler (ör. yazılmamış sürüm notu) özette "—" olarak gürültü yapmasın.
  return Object.entries(params as Record<string, unknown>)
    .filter(([k]) => k !== "app")
    .map(([k, v]) => [k, paramValue(k, v)] as const)
    .filter(([, v]) => v !== "—")
    .map(([k, v]) => `${paramLabel(k)}: ${v}`)
    .join(" · ");
}
